/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  contactBriefs: [],
  serverError: null,
};

export const actions = {
  async getContactBriefs({ commit }) {
    await api.get('/contact/briefs').then(async (response) => {
      commit('SET_CONTACT_BRIEFS', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_CONTACT_BRIEFS', []);
      commit('SET_SERVER_ERROR', exception);
    });
  },
};

export const mutations = {
  SET_CONTACT_BRIEFS(state, data) {
    state.contactBriefs = data;
  },
  SET_SERVER_ERROR(state, exception) {
    state.serverError = exception;
  },
};
